import script from "./LiveOverview.vue?vue&type=script&setup=true&lang=js"
export * from "./LiveOverview.vue?vue&type=script&setup=true&lang=js"

import "./LiveOverview.vue?vue&type=style&index=0&id=3f4a6133&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3f4a6133"]])

export default __exports__